import { useEffect, useMemo, useState } from "react";
import { connect, useDispatch } from "react-redux";
import Button from "../../../../../components/Button";
import ReactSelect from "../../../../../components/FormikForm/ReactSelect";
import { getAllCategories } from "../../../../../store/actions/category";
import { showModal } from "../../../../../store/actions/modal";
import {
  Label
} from './styles'
import { Group } from "../../../../../types";
import { CategoryDto } from "../../../../../types/category";
import Category from '../../../Category'
import Icon from "../../../../../components/Icon";
import padlockLockedIcon from '../../../../../assets/icons/padlock.svg'

interface ComponentProps {
  allCategories: CategoryDto[];
  allCategoriesState: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
  group: Group
  name;
  error;
  touched;
  onChange;
  onBlur;
}

const Component = ({
  allCategories,
  allCategoriesState,
  group,
  ...rest
}: ComponentProps) => {
  const [createNewCategoryVisible, setCreateNewCategoryVisible] = useState<boolean>(false)
  const dispatch = useDispatch();

  const humanReadableTime = (category) => {
    const days = category?.days_to_unlock;
    if (!days) return;

    if (days < 0) {
      throw new Error("La cantidad de días no puede ser negativa");
    }

    if (days < 7) {
      return days === 1
        ? "1 día"
        : `${days} días`;
    } else if (days < 30) {
      const weeks = Math.round(days / 7);
      return weeks === 1
        ? "1 semana"
        : `${weeks} semanas`;
    } else if (days < 365) {
      const months = Math.round(days / 30);
      return months === 1
        ? "1 mes"
        : `${months} meses`;
    } else {
      const years = Math.round(days / 365);
      return years === 1
        ? "1 año"
        : `${years} años`;
    }
  };

  const categories = useMemo(() => {
    return !!allCategories && allCategories.length > 0
      ? allCategories?.map((category) => {
        const date = humanReadableTime(category)
        return {
          label: (
            <Label>
              {category.name}
              {category?.is_unlockable && (
                <span>
                  <Icon icon={padlockLockedIcon} size="14px" color="#88451D" />
                  {date}
                </span>
              )}
            </Label>),
          value: category.id,
        }
      })
      : [];
  }, [allCategories]);

  useEffect(() => {
    if (group) {
      dispatch(getAllCategories({ group_id: group?.id, sort_by: 'category_order:asc' }));
    }
  }, [group]);

  return (
    <>
      <ReactSelect
        placeholder="Selecciona una o más categorías"
        items={categories}
        isMulti
        isClearable
        options={{
          label: "Categoría",
          marginBottom: 40,
          loading: allCategoriesState.loading,
          noOptionsText: "No se encuentra la catategoria",
          helperText: (
            <>
              {" "}
              Asócialo a una o más categorías para tener tus artículos
              organizados{" "}
              <Button
                onClick={() => setCreateNewCategoryVisible(!createNewCategoryVisible)}
                type="button"
                options={{
                  skin: "purple",
                  size: "md",
                  type: "link",
                }}
                style={{
                  margin: "5px 0px 0px 0px",
                  textDecoration: "underline",
                }}
              >
                Crear nueva categoría
              </Button>
            </>
          ),
        }}
        {...rest}
      />

      <Category showCategories={false} showCreateCategory={createNewCategoryVisible} onClose={() => { }} />
    </>
  );
};

const state = ({ categoryStore, groupStore }) => {
  const { data: allCategories, states: allCategoriesState } =
    categoryStore.allCategories;
  const { data: group } = groupStore.group;

  return {
    allCategories,
    allCategoriesState,
    group
  };
};

export default connect(state)(Component);
